import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import {
  addSchedule,
  addScheduleFailed,
  addScheduleSuccess,
  getSchedule,
  getScheduleFailed,
  getScheduleSuccess,
  updateScheduleStatus,
  updateScheduleStatusFailed,
  updateScheduleStatusSuccess,
} from './slice';
import * as endpoints from './endpoint';
import { request } from '@app/services';
import { RootState } from '@app/redux/root-reducer';

function* addScheduleSaga(action: ReturnType<typeof addSchedule>): any {
  try {
    const { name, priority, date, description } = action.payload;
    const { data } = yield select((store: RootState) => store.managerDashboardReducer.schedules);
    const result = yield call(request.post, endpoints.addSchedule, {
      name,
      priority,
      date,
      description,
    });
    yield put(addScheduleSuccess(result.data));
    yield put(getScheduleSuccess([...data, result.data]));
  } catch (err) {
    yield put(addScheduleFailed(err));
  }
}
//
function* getScheduleSaga(action: ReturnType<typeof getSchedule>): any {
  try {
    const result = yield call(request.get, endpoints.schedules);
    yield put(getScheduleSuccess(result.data));
  } catch (err) {
    yield put(getScheduleFailed(err));
  }
}
//
function* updateScheduleStatusSaga(action: ReturnType<typeof updateScheduleStatus>): any {
  try {
    const { taskId, status } = action.payload;
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateScheduleStatus}${taskId}`, {
      status,
    });
    yield put(updateScheduleStatusSuccess(result.data));
  } catch (err) {
    yield put(updateScheduleStatusFailed(err));
  }
}

function* ManagerDashboardSagas() {
  yield all([
    takeLatest(addSchedule, addScheduleSaga),
    takeLatest([getSchedule], getScheduleSaga),
    takeLatest(updateScheduleStatus, updateScheduleStatusSaga),
  ]);
}
export { ManagerDashboardSagas };
